import { render } from "./ListBAST.vue?vue&type=template&id=03a598cc&scoped=true"
import script from "./ListBAST.vue?vue&type=script&lang=js"
export * from "./ListBAST.vue?vue&type=script&lang=js"

import "./ListBAST.vue?vue&type=style&index=0&id=03a598cc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a598cc"]])

export default __exports__